import promiseContainer from 'components/hoc/promiseContainer';
import withBrowserState from 'components/hoc/withBrowserState';
import { listCanvas } from 'api/canvas';

import CanvasOverview from './CanvasOverview';

function mapPropsToPromises(props) {
  return {
    canvasData: listCanvas(),
  };
}

export default promiseContainer(mapPropsToPromises)(
  withBrowserState(CanvasOverview),
);



// WEBPACK FOOTER //
// ./src/components/CanvasOverview/CanvasOverviewContainer.js